import { IAplosApiRequestArgs } from "@/services/aplosApi";
import { ExecutionWorkflowType } from "./ExecutionWorkflowType";
import { ExecutionStatusType } from "./ExecutionStatusType";
import { GetExecutionsViewType } from "./GetExecutionsViewType";


export interface GetExecutionsArgsOptions {
    userId: string;
    tenantId: string;
    executionWorkflowType: ExecutionWorkflowType;
    startDate?: string;
    endDate?: string;
}

export class GetExecutionsArgs implements IAplosApiRequestArgs {

    // Limit/paginate number of values returned
    public limit?: number;
    // Populate with 'nextKey' value for paginated response to get proximal page
    public startKey?: string;
    // Filter on status
    public status?: ExecutionStatusType;
    // Return results with or without hierarchic (children) pre-populated
    public viewType?: GetExecutionsViewType;
    // Controls root > child enrichment
    public rootOnly?: boolean;
    // Filter on lifecycle state (active, archived, deleted). Omit to use backend default.
    public lifecycleState?: string;
    // Filter by folder assignment. Use "unassigned" for executions with no folder.
    public folderId?: string;

    public userId: string;
    public tenantId: string;
    public executionWorkflowType: ExecutionWorkflowType;
    public startDate?: string;
    public endDate?: string;

    constructor(options: GetExecutionsArgsOptions) {

        if (options.userId == null) throw Error("userId is required");
        if (options.tenantId == null) throw Error("tenantId is required");
        if (options.executionWorkflowType == null) throw Error("executionWorkflowType is required");

        this.userId = options.userId;
        this.tenantId = options.tenantId;
        this.executionWorkflowType = options.executionWorkflowType;
        this.startDate = options.startDate;
        this.endDate = options.endDate;
    }

}